import { useRouter } from '../../components/contexts/RouterContextManager';

const useBasicProLayout = () => {
    const { layout, menuItems } = useRouter();

    if (layout?.__typename !== 'BasicProLayout') {
        throw new Error('Unexpected Layout type');
    }

    return { layout, menuItems };
};

export default useBasicProLayout;
